import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 10000,
    headers: {'auth': process.env.REACT_APP_API_AUTH}
});

export default api;